/* eslint-disable import/prefer-default-export */
import { takeEvery, put, select } from 'redux-saga/effects';
import { endCall, rejectCall, endCallByRemote, rejectCallByRemote } from '../communicationVideo/actions';
import { callHistory } from './entities';
import { isAuthenticated } from '../auth/selectors';
import { getLogger } from '../../logger/index';

const logger = getLogger('communication');

function* handleEndCall() {
  try {
    if (yield select(isAuthenticated)) {
      const fetchListAction = callHistory.fetchList();
      yield put(fetchListAction);
    }
  } catch (e) {
    logger.error('Handle end call err', e);
  }
}

export default function* callHistorySaga() {
  yield takeEvery(endCall, handleEndCall);
  yield takeEvery(rejectCall, handleEndCall);
  yield takeEvery(endCallByRemote, handleEndCall);
  yield takeEvery(rejectCallByRemote, handleEndCall);
}
